import { useLocation } from 'react-router-dom';

import { Nav } from '@components/nav';
import { HireNav } from '@components/nav/nav';

import { useProfileNavigationItems } from 'hooks/use-profile-navigation-items';
import { useStore } from 'models/Provider';

type LocationState = {
  from: string;
};

export const ProfileNavigation = () => {
  const { t } = useStore();
  const items = useProfileNavigationItems();
  const location = useLocation();
  const { from } = (location.state as LocationState) || { from: '/' };

  return (
    <HireNav
      variant="static"
      fixedHeader={
        <Nav.Header logo={<Nav.HeaderBackLink href={from} label={t('navigation.back')} />} />
      }
    >
      <Nav.GroupHeader text={t('navigation.profile.headers.profile')} />
      <Nav.Group>
        {items.map((item) => (
          <Nav.Link key={item.path} href={item.path} label={item.label} iconLeft={item.icon} />
        ))}
      </Nav.Group>
    </HireNav>
  );
};
